const getters = {
  username: (state) => state.loginStore.username,
  phone: (state) => state.loginStore.phone,
  userLoginInfo: (state) => state.loginStore.userLoginInfo,
  envType: (state) => state.loginStore.envType,
  currentClientId: (state) => state.loginStore.currentClientId,
  defaultEnvOfTwo: (state) => state.loginStore.defaultEnvOfTwo,
  baseInfo: (state) => state.loginStore.baseInfo,
  defaultActiveIndex: (state) => state.loginStore.defaultActiveIndex,
  paneActiveName: (state) => state.loginStore.paneActiveName,
  envApi: (state) => state.loginStore.envApi,
  isGoHomeBtn: (state) => state.app.isGoHome,
  currentAppShow: (state) => state.app.currentApp,
};
export default getters;
